(() => {
  if (!customElements.get('rorilio-mask-bundle')) {
    class RorilioMaskBundle extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.root = document.getElementById(`MainProduct-${this.dataset.sectionId}`);
        const data = this.querySelector('[data-variants]');
        if (!this.root || !data) return;
        this.variants = JSON.parse(data.textContent);
        this.ready = true;
        this.addEventListener('change', event => {
          if (event.target.matches('input[type="radio"]')) this.update();
        });
        // Dawn reads FormData on submit; reconcile with the actual checked offer first.
        this.root.addEventListener('submit', event => {
          if (event.target.matches('form[action*="/cart/add"]') && !this.update(false)) {
            event.preventDefault();
            event.stopImmediatePropagation();
          }
        }, true);
        this.update();
      }
      update(updateUrl = true) {
        const checked = this.querySelector('input[type="radio"]:checked');
        const variant = this.variants.find(item => item.id === Number(checked?.value));
        const available = Boolean(variant?.available);
        this.querySelectorAll('[data-variant]').forEach(card => {
          card.classList.toggle('is-selected', Number(card.dataset.variant) === variant?.id);
        });
        this.root.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach(input => {
          input.value = variant ? String(variant.id) : '';
          input.disabled = !available;
          input.dispatchEvent(new Event('change', {bubbles: true}));
        });
        this.root.querySelectorAll('button[name="add"]').forEach(button => {
          button.disabled = !available;
          const label = button.querySelector('span');
          if (label) label.textContent = available ? 'AGREGAR AL CARRITO' : 'NO DISPONIBLE';
        });
        if (variant && updateUrl) {
          const url = new URL(location.href);
          url.searchParams.set('variant', variant.id);
          history.replaceState({}, '', url);
        }
        document.dispatchEvent(new CustomEvent('rorilio:mask-variant', {detail: variant || null}));
        return available;
      }
    }
    customElements.define('rorilio-mask-bundle', RorilioMaskBundle);
  }
  if (window.rorilioMaskEventsBound) return;
  window.rorilioMaskEventsBound = true;
  document.addEventListener('input', event => {
    if (!event.target.matches('.rym-compare input[type="range"]')) return;
    const value = Math.min(100, Math.max(0, Number(event.target.value)));
    event.target.closest('.rym-compare').style.setProperty('--rym-split', value + '%');
    event.target.setAttribute('aria-valuetext', `Divisor al ${value}%`);
  });
  document.addEventListener('click', event => {
    const top = event.target.closest('[data-rym-top]');
    if (top) {
      event.preventDefault();
      document.querySelector('.rorilio-mask-product product-info')?.scrollIntoView({behavior: 'smooth'});
    }
    const button = event.target.closest('[data-rym-review-dir]');
    if (button) {
      const track = button.closest('.rym-module').querySelector('.rym-cards');
      track.scrollBy({left: Number(button.dataset.rymReviewDir) * (track.clientWidth * .84 + 16), behavior: 'smooth'});
    }
  });
  document.querySelectorAll('.rym-module-marquee .rym-cards').forEach(track => {
    if (track.dataset.loopReady) return;
    track.dataset.loopReady = 'true';
    [...track.children].forEach(item => {
      const copy = item.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      track.append(copy);
    });
  });
})();
